<script>
  import Channel from './Channel.svelte'

  export let reviewchannel
  export let showIconOnReview
</script>

<Channel {reviewchannel} {showIconOnReview} />
